import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import DeleteAccount from "@/pages/DeleteAccount";
import ComingSoon from "@/pages/ComingSoon";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/" element={<ComingSoon />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
